/**
 * Tab相关API
 */

import { pepperClient, DomainType } from "@/lib/request";
import { CommonRequestParams } from "@/types/commonParams";
import { Tab } from "@/types/tab";
import { ssrFetch } from "@/lib/ssrFetch";

/**
 * Tab相关API路径
 */
const TAB_API_PATHS = {
  // Tab列表和金刚区规则
  SEARCH_RULE: "/api/product/search/rule",
} as const;

// 导出路径常量供外部使用
export { TAB_API_PATHS };

export interface TabListRequestParams extends CommonRequestParams {
  // cityId: number;
  // platform: number;
  tabId: number | null;
  searchRuleScene: number;
  wayneId: number | null;
  cType: string;
  segmentIdList: Array<number> | null;
  // userId: string;
  // ctype: string;
  // _ver: string;
  // uuid: string;
  // osVersion: string;
}

export interface TabListResponse {
  tabList: Array<Tab>;
  // quickSelection: Array<QuickSelection>;
  // geoConfigList: Array<any>;
  // businessAreaList: Array<any>;
  // sortConfigList: Array<any>;
  // speed: Array<any>;
  // navigationConfigList: Array<any>;
}

/**
 * 获取Tab列表
 */
export async function getTabList(params: TabListRequestParams) {
  return pepperClient.get<TabListRequestParams, TabListResponse>({
    url: TAB_API_PATHS.SEARCH_RULE,
    data: params,
  });
}

/**
 * =====================================================
 * SSR兼容函数
 * =====================================================
 */

/**
 * SSR环境获取Tab列表和金刚区配置
 * 与CSR完全一致的API设计：只接收一个业务参数
 * @param requestParams 请求参数（包含commonParams和业务参数）
 * @returns Tab列表完整响应
 */
export async function fetchSearchRuleForSSR(
  requestParams: TabListRequestParams,
): Promise<TabListResponse> {
  const response = await ssrFetch.get<TabListResponse, TabListRequestParams>(
    DomainType.PEPPER,
    TAB_API_PATHS.SEARCH_RULE,
    requestParams,
  );

  // 返回完整响应结构,与CSR保持一致
  return response?.data;
}
